import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => [{ title: "Privacy Policy – Ecofo" }];

export default function PrivacyPolicy() {
  return (
    <div className="text-white min-h-screen overflow-auto" style={{ backgroundColor: '#050B0A' }}>
      <div className="container mx-auto px-6 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-gray-400 mb-10 text-sm">Last updated: March 2026</p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>
          <p className="text-gray-300 leading-relaxed">
            We collect information you provide directly (such as your name, email address, and account details) and information generated through your use of the Service (such as session recordings and clips you create).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">2. How We Use Your Information</h2>
          <p className="text-gray-300 leading-relaxed">
            We use your information to operate and improve the Service, communicate with you, and ensure the security of your account. We do not sell your personal information to third parties.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">3. Sharing of Information</h2>
          <p className="text-gray-300 leading-relaxed">
            We may share your information with third-party service providers who help us operate the Service (e.g., cloud storage, authentication). These providers are bound by confidentiality obligations. We may also disclose information when required by law.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">4. Cookies</h2>
          <p className="text-gray-300 leading-relaxed">
            We use cookies and similar technologies to maintain your session and improve your experience. You can control cookie settings through your browser.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">5. Data Retention</h2>
          <p className="text-gray-300 leading-relaxed">
            We retain your data for as long as your account is active or as needed to provide the Service. You may request deletion of your account and associated data by contacting us.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">6. Security</h2>
          <p className="text-gray-300 leading-relaxed">
            We take reasonable measures to protect your information from unauthorized access, loss, or misuse. However, no internet transmission is completely secure.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">7. Children's Privacy</h2>
          <p className="text-gray-300 leading-relaxed">
            The Service is not directed to children under 13. We do not knowingly collect personal information from children under 13.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">8. Changes to This Policy</h2>
          <p className="text-gray-300 leading-relaxed">
            We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page with an updated date.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">9. Contact</h2>
          <p className="text-gray-300 leading-relaxed">
            Questions about this policy? Email us at <span className="text-green-400">admin &lt;at&gt; ecofo.org</span>.
          </p>
        </section>
      </div>
    </div>
  );
}
